import Sliders from '../modules/sliders';
import LazyLoadImages from '../modules/lazyLoadImages';

const URL = '/ValsparApi/ColourSubcategoryCarousel/?';

export default function ColourSubcategoryCarousel() {
    colourSubcategory();
}

function colourSubcategory () {
    let container = document.querySelector('.js-colour-subcategory-carousel');
    if(!container) return;
    let additionalId = container.querySelector('.additionalId').value || '0';
    let pageId = container.querySelector('.pageId').value || '0';
    window.emitter.addListener('applyFilters', ( asString ) => {
        let urlParams = new URLSearchParams(window.location.search);
        let filterParams = new URLSearchParams(asString);
        if (filterParams.has('c') && filterParams.get('c') !== urlParams.get('c')) {
            let colourCode = filterParams.get('c');
            let url = URL + 'colourId=' + colourCode + '&additionalId=' + additionalId + '&pageid=' + pageId;

            fetch(url,
                {
                    method: 'GET',
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                })
                .then(
                    response => response.text()
                )
                .then(
                    html => {
                        var updatedHtml = document.createElement('div');
                        updatedHtml.innerHTML = html.trim();
                        container.innerHTML = updatedHtml.querySelector('.js-colour-subcategory-carousel')?.innerHTML || '';
                    }
                )
                .then(
                    () => {
                        Sliders();
                        LazyLoadImages();
                    }
                )
                .catch(
                    error => console.log(error.message)
                )
            ;
            }
    });
}
